import _ from 'lodash';
import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import PortalLayer from '../../layout/viewer/layers/PortalLayer';
import { viewerDisabledPortals } from '../../layout/viewer/store/viewer.state';
import {
  routingPolicyRule,
  routingPolicySelectedIdentity,
} from '../store/routingPolicy/routingPolicy.state';

const SimulationPortalLayer: React.FC = () => {
  const selectedIdentity = useRecoilValue(routingPolicySelectedIdentity);
  const [disabledPortals, setDisabledPortals] = useRecoilState(
    viewerDisabledPortals,
  );
  const [rule, setRule] = useRecoilState(
    routingPolicyRule(selectedIdentity?.ruleId),
  );

  useEffect(() => {
    if (selectedIdentity?.isRoutingPortalsSelected) {
      setDisabledPortals(
        _(rule?.portalRules)
          .filter(r => r.blocked)
          .keyBy(r => r.portalId)
          .value(),
      );
    }
    return () => {
      setDisabledPortals({});
    };
  }, [rule?.portalRules]);

  const onClick = (portalId: string, isDisabled: boolean) => {
    if (!selectedIdentity?.isRoutingPortalsSelected) return;
    const portalRules = _(rule?.portalRules)
      .filter(r => r.portalId !== portalId)
      .push({ portalId, blocked: isDisabled })
      .value();
    setRule(current => ({
      ...current,
      portalRules,
    }));
  };

  return (
    <PortalLayer onClick={id => onClick(id, !_.has(disabledPortals, id))} />
  );
};

export default SimulationPortalLayer;
